<div class="download-units-graph">
  <div class="mat-subheading-2" fxLayout fxLayoutGap="4px" fxLayoutAlign="start cetner">
    <mat-icon>insert_chart_outlined</mat-icon>
    <div>
      <span>ダウンロード数</span>
    </div>
    <mat-icon class="help"
      matTooltip="上部カレンダーで期間指定された範囲のダウンロード数 (実売値)【Amazon、Apple、Avex、Digimerce、Dwango、Google、Label Gate、Line Music、MTI、OTOTOY、Oricon、RecoChoku、YMM】をグラフ化しています。">
    help_outline</mat-icon>
    <app-csv-download [id]="csvId" [fileName]="csvFileName" [csv]="csvData$ | async" [loading]="isLoading$ | async"
    [artist]="selectedArtist$ | async"></app-csv-download>
  </div>
  <mat-card>
    <mat-card-content>
      <div class="chartWithOverlay" fxFlex="1 1 auto">
        @if (subAccounts$ | async; as labels) {
        <div #container fxLayout fxLayoutAlign="center center" class="container">
          @if (!(isLoading$ | async)) {
          @if (units$ | async; as data) {
          <div class="chart-wrapper" fxLayoutAlign="start stretch" fxLayout="column" #wrapper fxFlex="1 1 auto"
               (window:resize)="onResize()">
            @if (!media.isActive('lt-md')) {
            <section class="checkbox-section">
              @for (checkLabel of checkLabels; track checkLabel) {
              <mat-checkbox class="checkbox-margin" [(ngModel)]="checkLabel.completed" color="primary"
                            (ngModelChange)="onChange()">{{ checkLabel.name }}</mat-checkbox>
              }
            </section>
            }
            <div class="div-chart">
              @if (data.length > 0) {
              <google-chart #chart class="chart" type="LineChart" [data]="data"
                            [columns]="labels" [options]="unitsOptions" [height]="300" [dynamicResize]="false"
                            (select)="onSelect($event)">
              </google-chart>
              }
            </div>
            <!-- <ng-container *ngIf="!(isLoading$ | async) && !media.isActive('lt-md')">
          <div class="overlay-text" fxLayoutAlign="start center" #wrapper fxFlex="1 1 auto">
            <div id="lblAmazon" fxLayoutAlign="start center">
              <div style="width: 32px;border-top: solid 2px #ff5722;"></div>
              <div>&nbsp;&nbsp;Amazon</div>
              <div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
            </div>
            <div id="lblApple" fxLayoutAlign="start center">
              <div style="width: 32px;border-top: solid 2px #ff9800;"></div>
              <div>&nbsp;&nbsp;Apple</div>
              <div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
            </div>
            <div id="lblReco" fxLayoutAlign="start center">
              <div style="width: 32px;border-top: solid 2px #3f51b5;"></div>
              <div>&nbsp;&nbsp;RecoChoku</div>
            </div>
          </div>
        </ng-container> -->
          </div>
          }
          } @else {
          <app-music-note></app-music-note>
          }
        </div>
        }
      </div>
      @if (!(dataCollectLoading$ | async)) {
      @if (!(dataCollections$ | async)) {
      <img class="datanofix_icon" src="./assets/data_collections.png" />
      } @else {
      <img class="datafix_icon" matTooltip="各項目において選択した期間のデータが全部揃っている場合に、チェックマークが表示されます。"
           src="./assets/data_collections.png" />
      }
      } @else {
      <img class="datanofix_icon" src="./assets/data_collections.png" />
      }
    </mat-card-content>
  </mat-card>
</div>



